import { gql } from "@apollo/client";

export const UPDATE_INVENTORY_DETAILS = gql`
  mutation updateInventoryListDetails{
    updateInventoryListDetails(doNext: true)
  }
`;
